import { NotificationView } from "@/data/types";
import Avatar from "@/views/Components/Avatar";
import ToggleFriendButton from "@/views/Components/ToggleFriendButton";
import { RoutePaths } from "@/views/routes";
import { generatePath, Link } from "react-router";

export function FriendAdded({
  notification,
}: {
  notification: NotificationView;
}) {
  return (
    <>
      <div className="flex flex-col gap-0 md:flex-row md:items-center md:gap-4">
        <Link
          className="flex flex-row items-center gap-4"
          to={generatePath(RoutePaths.specificWishlist, {
            wishlistId: notification.wishlistId || "",
          })}
        >
          <Avatar uid={notification.sourceUserId} />
          <div className="H6 wish-light-primary">
            {notification.sourceUserDisplayName}
          </div>
        </Link>
        <div className="ml-14 md:m-0">added you as a friend</div>
        <ToggleFriendButton
          className="ml-14 mt-4 md:m-0"
          uid={notification.sourceUserId}
        />
      </div>
    </>
  );
}
